import SmallDelete from '@/components/atom/icon/SmallDelete';
import { DeeplinkLoggerEventName } from '@/constants/logs/deeplink';
import { useAirbridgeDynamicLink } from '@/shared/hooks';
import { DynamicLinkContent } from '@/shared/types';
import theme from '@/styles/theme';
import React from 'react';

export type TrackingInfo = {
  campaign?: string;
  contentId?: string;
  contentTitle?: string;
  contentCategory?: string;
  contentSubCategory?: string;
};

type AppInstallTopBannerProps = {
  content: DynamicLinkContent;
  onClickClose: () => void;
  trackingInfo?: TrackingInfo;
  onLogEvent?: () => void;
};

const AppInstallTopBanner = ({ onClickClose, content, trackingInfo, onLogEvent }: AppInstallTopBannerProps) => {
  const { contentCategory, contentId, contentTitle, campaign, contentSubCategory } = trackingInfo ?? {};
  const airbridgeDynamicLink = useAirbridgeDynamicLink();

  const onClickInstallApp = () => {
    onLogEvent?.();
    airbridgeDynamicLink.navigateWithTracking(DeeplinkLoggerEventName.ClickCtaButton, {
      campaign: campaign,
      content: content,
      term: '바로 진료받기',
      sub_id: contentId,
      sub_id_1: contentTitle,
      sub_id_2: contentCategory,
      ...(contentSubCategory && { sub_id_3: contentSubCategory }),
    });
  };

  return (
    <div className='sticky top-[60px] z-[300] flex w-full items-center justify-between bg-gray-700 pt-[14px] pr-[20px] pb-[12px] pl-[12px]'>
      <div className='flex gap-[12px]'>
        <button onClick={onClickClose}>
          <SmallDelete color={theme.color.gray300} size={24} />
        </button>
        <div className='flex flex-col'>
          <span className={'typography-ui-13m text-white'}>병원 문 닫은 늦은 밤, 주말에도</span>
          <span className={'typography-ui-15sb text-white'}>닥터나우는 24시간 열려있어요!</span>
        </div>
      </div>
      <div>
        <button
          className='typography-ui-13m h-[32px] rounded-lg border bg-primary-600 px-[8px] text-white'
          onClick={onClickInstallApp}
        >
          바로 진료받기
        </button>
      </div>
    </div>
  );
};

export default AppInstallTopBanner;
